import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Calendar } from 'primereact/calendar';
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';



export const NoticeActivity = ({noticeActivities, codeCas}) => {


    const CODE_ACTIVITY_AUTHORISED="ACTIVITY_AUTH";
    const CODE_ACTIVITY_NOT_AUTHORISED="ACTIVITY_NOT_AUTH";
    const ALL_ACTIVITIES_ALLOWED="Toutes les activités."



    const getActivityByCode = (code) => {
        let rawHtml=ALL_ACTIVITIES_ALLOWED;
        noticeActivities.forEach( activity => {
                    if(activity.code==code){
                        rawHtml=activity.rawHtml;
                    }
         });
         return rawHtml;
     };



    return (
        <div >
            <ul>
                <li>
                              {(codeCas == "3742") && <div> <b>Sont prise en compte</b> les activités telles que :</div>}
                              {(codeCas == "3743") && <div> Sont prise en compte les activités sportives, de loisirs ou culturelles telles que :</div>}

                                <ul>
                                    <li dangerouslySetInnerHTML={{__html: getActivityByCode(CODE_ACTIVITY_AUTHORISED)}}>
                                    </li>
                                </ul>
                </li>

                {!(getActivityByCode(CODE_ACTIVITY_AUTHORISED) == ALL_ACTIVITIES_ALLOWED) && <li>
                              {(codeCas == "3742") && <div> <b>Ne sont pas prise en compte</b> au titre de cette prestation :</div>}
                              {(codeCas == "3743") && <div>Les activités ci-dessous ne sont pas prise en compte au titre de cette prestation :</div>}
                              <ul>
                                <li dangerouslySetInnerHTML={{__html: getActivityByCode(CODE_ACTIVITY_NOT_AUTHORISED)}}>

                                </li>
                              </ul>
                </li>}
            </ul>

        </div>
    );
}
